import { Teacher } from "@app/shared/types";
import { Typography, alpha } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

interface TeachersPageImageCardProps {
    teacher: Teacher;
    onClick: () => void;
}

const useStyles = makeStyles((theme) => ({
    card: {
        position: "relative",
        height: "450px",
        [theme.breakpoints.down("sm")]: {
            height: "400px",
        },
        [theme.breakpoints.down("xs")]: {
            height: "350px",
        },
        borderRadius: theme.borderRadius.default,
        cursor: "pointer",
        boxShadow: theme.shadow.default,
        transition: "transform .3s",
        "&:hover": {
            transform: "scale(1.05)",
            boxShadow: theme.shadow.spread,
        },
        "&:hover $hoverOverlay": {
            backgroundColor: alpha(theme.palette.grey900, 0.3),
        },
        "&:active": {
            opacity: 0.8,
        },
    },
    avatar: {
        width: "100%",
        height: "100%",
        borderRadius: theme.borderRadius.default,
        objectFit: "cover",
    },
    nameOverlay: {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        height: "50%",
        borderRadius: theme.borderRadius.default,
        display: "flex",
        alignItems: "end",
        justifyContent: "center",
        background: `linear-gradient(180deg,hsla(0,0%,100%,0),${theme.palette.grey900})`,
    },
    hoverOverlay: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: theme.borderRadius.default,
        backgroundColor: "transparent",
        transition: "background-color .3s",
    },
    name: {
        color: "white",
        textAlign: "center",
        marginBottom: 0,
    },
}));

export const TeachersPageImageCard: React.FC<TeachersPageImageCardProps> = ({
    teacher,
    onClick,
}) => {
    const classes = useStyles();
    return (
        <div className={classes.card} onClick={onClick} data-testid="teachersPageImageCard">
            <div className={classes.hoverOverlay} />
            <img className={classes.avatar} src={teacher.picture || undefined} alt={teacher.name} />
            <div className={classes.nameOverlay}>
                <Typography variant="h2" className={classes.name}>
                    {teacher.name}
                </Typography>
            </div>
        </div>
    );
};
